import { useMutation } from "@tanstack/react-query"
import axios from "axios"

export const useUploadBubbleImageMutation = () => {
  return useMutation({
    mutationFn: async (file: FileList) => {
      const { data } = await axios.post(`/integrations/widget/media`, {
        file,
      })
      return data.data
    },
  })
}
